exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photos[data-v-28193dbe] {\n  justify-content: unset;\n  margin-bottom: 20px;\n}\n.photos > div[data-v-28193dbe] {\n  margin-bottom: 15px;\n  opacity: 1;\n  transition: opacity 0.3s;\n}\n.photos > div[data-v-28193dbe] :hover {\n  cursor: pointer;\n  opacity: 0.9;\n  transition: opacity 0.3s;\n}", ""]);

// exports
